<template>
<div :style="cssProps">
    <div class="logo-title d-flex flex-row justify-content-between align-items-center">
      <div>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" @click="$router.push({name:'startPage'})">
        <div class="d-flex flex-column logo-col" style="padding-left:15px;">
          <h1 class="titleTop">Burger & Fries</h1>
          <h2 class="subTitleTop">Search or View Nearby Restaurants Below.</h2>
        </div>
      </div>
      <div>
        <button class="signIn d-flex align-items-center justify-content-around">
          <i class="fal fa-user-circle"></i>
          <span>Account</span>
        </button>
      </div>
  
    </div>
  <div class="allin">
    <div class="main-content d-flex flex-row justify-content-center align-items-center">
        <i class="fal fa-long-arrow-alt-left" @click="$router.go(-1)"></i>
        <div class="d-flex flex-column">
        <h1 class="title">LOG IN OR CREATE AN ACCOUNT</h1>
        <h2 class="subTitle">Enter to account using your social network account or email address.</h2>
      
        </div>
      
    </div>
    <div class="main d-flex justify-content-center align-items-center flex-row">
      <div class="social d-flex flex-column">
      <h1>Recomended</h1>
    </div>
    </div>
    <div class="row-method d-flex flex-row justify-content-center align-items-center">
       <button class="method d-flex flex-column justify-content-between align-items-start">
       <i class="fab fa-facebook-square"></i>
        <span>Facebook</span>
       </button>
      <button class="method d-flex flex-column justify-content-between align-items-start">
       <i class="fab fa-twitter"></i>
        <span>Twitter</span>
      </button>
      <button class="method d-flex flex-column justify-content-between align-items-start">
       <i class="fab fa-google"></i>
        <span>Google</span>
      </button>
      <button class="method d-flex flex-column justify-content-between align-items-start">
        <i class="fab fa-microsoft"></i>
        <span>Microsoft</span>
      </button>
      
    </div>
    
    <div class="main d-flex justify-content-center align-items-center flex-row">
      <div class="social d-flex flex-column">
      <h1>Use your email address</h1>
      <input placeholder="Enter your email address to continue" v-model="email" name="emailaddress" v-validate="'required|email|max:128'">
      <span class="not-work">{{ errors.first('emailaddress') }}</span>
      <span class="description">
        The Seven Girls app is paired with Olo service. If you have a Olo account, use your credentials to log into or create your Seven Girls account.
      </span>
      <div class="last">
      <button class="last-btn" @click="submit">
        <span>Continue</span>
      </button>
      </div>
    </div>
    </div>

   
   
    
</div>
    </div>
</template>
<script>
import {mapState} from "vuex";
import axios from 'axios';
export default {
  name: 'registerFirst',
  $_veeValidate: {
    validator: 'new', 
  },
  data(){
    return{
      email: null
    }
  },
  computed:{
      ...mapState(["info"]),
          cssProps() { return {
            '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
          }
        },
  },
  methods: {
    async submit(){
      const checking = await this.$validator.validateAll();
      if(checking){
        
        this.$store.commit('email.set', {emailaddress: this.email});
        //check if user exists
        // axios.get(`https://secure-badlands-41449.herokuapp.com/users/exists?email=${this.email}includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP`)
        // .then(response => {
        //   console.log(response.data)
        // }).catch(error => {
        //   console.log(error)
        // })
        this.$router.push({name:'Signup'});
      }
    }
  }
    
}
</script>
<style scoped>
.not-work{
    
	height: 24px;
width: 240px;
border-radius: 4px;
/* background-color:var(--main-color); */
color: var(--main-color);
font-family: Poppins;
font-size: 10px;
font-weight: 400;
line-height: 16px;
word-spacing:1.2px;
position: relative;
top: 10px;
text-align: center;

}
.allin
{
    position: absolute;
    margin: auto;
    top:80px;
    left: 0;
    bottom: 0;
    right: 10%;
}
.last
{
  padding-top: 24px;
}
.last-btn span{
  
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
}

.last-btn
{
	height: 48px;
	width: 201px;
	border-radius: 24px;
	background-color: var(--main-color);
}

.description
{
  padding-top: 24px;
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;
  width: 360px;
}

input{
 
  border: none;
  outline: none;
  background-color: rgba(255,255,255,0);
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
  height: 56px;
  width: 360px;
  padding: 18px 0;
}
input::placeholder
{
  
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.row-method
{
  width: 100%;
  padding-left: 10%;
  padding-top: 24px;
}
.method i {
  
	opacity: 0.8;
	color: var(--main-color);
	font-family: "Font Awesome 5 Brands";
	font-size: 20px;
	line-height: 21px;
}

.method span
{
  
	opacity: 0.8;
	color: var(--main-color);
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
}
.method
{
  padding: 24px;
	height: 112px;
	width: 158px;
	border: 1px solid var(--main-color);
	border-radius: 16px;
	background-color: #FFFFFF;
  margin-left: 8px;

}

.main{
  width: 100%;
}
.social
{
    width: 500px;
    padding-top: 48px;
}
.social h1{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
  text-align: left;

}
.main-content
{
    width: 100%;
    padding-top: 47px;
}
.main-content i 
{
   
	opacity: 0.6;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 32px;
	font-weight: 300;
	line-height: 32px;
    padding-right: 48px;

}
.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 35px;
  color: #000000;
  text-align: left;

}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap
}
button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.titleTop {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitleTop {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.logo-title {
  padding: 15px 25px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register/registerFirst.vue